export default "__VITE_ASSET__DeIZt1K___"